/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AbsentAlertList.vue?vue&type=template&id=52df3957&scoped=true&"
import script from "./AbsentAlertList.vue?vue&type=script&setup=true&lang=js&"
export * from "./AbsentAlertList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AbsentAlertList.vue?vue&type=style&index=0&id=52df3957&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df3957",
  null
  
)

export default component.exports